import { render, staticRenderFns } from "./VentilationCard.vue?vue&type=template&id=07d4692a"
import script from "./VentilationCard.vue?vue&type=script&lang=js"
export * from "./VentilationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports